import { render, staticRenderFns } from "./MemberList.vue?vue&type=template&id=4801c5be"
import script from "./MemberList.ts?vue&type=script&lang=ts&external"
export * from "./MemberList.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports